import React, { type DragEvent } from 'react';
import { isFunction } from '../../../helpers/general-helpers';
import styles from './DragAndDropAria.module.scss';
import Button from '../../Button/Button';
import Upload from '../../Icons/Upload';

export interface IDragAndDropAriaProps {
  parentId: string;
  onBrowse: () => void;
  onChange: (file: File) => void;
}

export default function DragAndDropAria({ parentId, onBrowse, onChange }: IDragAndDropAriaProps) {
  function browse() {
    if (isFunction(onBrowse)) onBrowse();
  }

  function onDrop(event: DragEvent<HTMLDivElement>): void {
    event.preventDefault();
    event.stopPropagation();

    if (!isFunction(onChange) || event.dataTransfer == null) {
      return;
    }

    const droppedFiles = event.dataTransfer.files;

    if (droppedFiles.length === 0) return;

    const files: File[] = Array.from(droppedFiles);
    onChange(files[0]);
  }

  return (
    <div
      className={`${styles['drop-aria']}`}
      onDrop={onDrop}
      onDragOver={(event) => {
        event.preventDefault();
      }}
    >
      <div className={`${styles['upload-container']}`}>
        <Button
          id={parentId + '_btnUpload'}
          mode="secondary"
          type="button"
          aria-label="Click here to browse your computer for the files to upload"
          onClick={browse}
          disabled={false}
          ariaLabel="Upload File"
        >
          <Upload />
          Upload File
        </Button>
        <span className={`${styles['drop-here']}`}>or drop here</span>
      </div>
    </div>
  );
}
